import ImagePanel from './SidePanel/Panels/ImagePanel';
import ButtonPanel from './SidePanel/Panels/ButtonPanel';
import DividerPanel from './SidePanel/Panels/DividerPanel';
import {
    AttachEmailTwoTone,
    CalendarViewDayTwoTone,
    HorizontalRuleTwoTone,
    PhotoSizeSelectActualTwoTone,
    SmartButtonTwoTone,
    SpaTwoTone,
    SpaceBarTwoTone,
    TextFieldsTwoTone,
    ViewArrayTwoTone,
    ViewComfyTwoTone,
    WysiwygTwoTone,
} from '@mui/icons-material';
import TextPanel from './SidePanel/Panels/TextPanel';
import SectionPanel from './SidePanel/Panels/SectionPanel';
// import i18n from '@i18n';
// import { t } from 'i18next';
import SpacerPanel from '@SidePanel/Panels/SpacerPanel';
import { get } from 'lodash';

const geti18nlanguage = () => {
    const lang = localStorage.getItem('i18nextLng') || 'en';
    return lang.split('-')[0];
};

const topLevelLocals = {
    he: {
        Button: 'כפתור',
        'Download File': 'הורד קובץ',
    },
    en: {},
};

const t = key => {
    const lang = geti18nlanguage();
    return get(topLevelLocals, `${lang}.${key}`, key);
};

// default styles
const bodyStyles = {
    'font-family': 'Arial, sans-serif',
    'word-break': 'break-word',
    'overflow-wrap': 'break-word',
};

const paragraphStyles = {
    'font-family': 'Helvetica',
    'font-size': '16px',
    color: '#555555',
    'line-height': '1.6',
    'letter-spacing': '0.66px',
    // 'margin-block-start': '8px',
    // 'margin-block-end': '8px',
    // 'line-height': '24px',
};

const linkStyles = {
    color: '#006495',
    'text-decoration': 'none',
    'font-weight': 'bold',
};

const headingOneStyles = {
    'font-family': 'Helvetica',
    'font-size': '32px',
    color: '#1a1c1e',
    'font-weight': 'normal',
};

const headingTwoStyles = {
    'font-family': 'Helvetica',
    'font-size': '24px',
    color: '#1a1c1e',
    'font-weight': 'normal',
};

const headingThreeStyles = {
    'font-family': 'Helvetica',
    'font-size': '20px',
    color: '#1a1c1e',
    'font-weight': 'normal',
};

const headingFourStyles = {
    'font-family': 'Helvetica',
    'font-size': '18px',
    color: '#1a1c1e',
    'letter-spacing': '0.2px',
};
const textStyles = {
    'white-space': 'pre-wrap',
};

const globalStyles = {
    paragraph: paragraphStyles,
    'heading-one': headingOneStyles,
    'heading-two': headingTwoStyles,
    'heading-three': headingThreeStyles,
    'heading-four': headingFourStyles,
    link: linkStyles,
    body: bodyStyles,
    text: textStyles,
};

const buttonAttributes = {
    style: {
        backgroundColor: '#006495',
        color: '#FFFFFF',
        // 'font-size': '16px',
        borderRadius: '99px',
        textAlign: 'center',
        // minWidth: 'max-content',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '24px',
        paddingRight: '24px',
    },
};

const theme = {
    button: buttonAttributes,
};

const attributes = { style: {} };

const textNode = { text: '' };

const paragraph = {
    type: 'paragraph',
    attributes: { style: {} },
    children: [textNode],
};

const headingOne = {
    type: 'heading-one',
    attributes: { style: {} },
    children: [textNode],
};

const richText = {
    type: 'rich-text',
    containerAttributes: {
        style: {
            paddingRight: '24px',
            paddingLeft: '24px',
        },
    },
    children: [paragraph],
};

const heading = {
    type: 'rich-text',
    containerAttributes: {
        style: {
            paddingRight: '24px',
            paddingLeft: '24px',
        },
    },
    children: [headingOne],
};

const text = { text: '' };
const column = {
    type: 'column',
    attributes: { style: { verticalAlign: 'top' } },
    children: [richText],
};
const row = {
    type: 'row',
    attributes: { style: { tableLayout: 'fixed' } },
    children: [column],
};
const placeholder = {
    type: 'placeholder',
    attributes: {
        style: {
            height: '100px',
        },
    },
    children: [text],
};

const section = {
    type: 'section',
    attributes: {
        style: {
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
        },
    },
    children: [placeholder],
};

const container = {
    type: 'container',
    attributes: {
        style: {
            // whiteSpace: 'pre-wrap',
            backgroundColor: '#f9f9fc',
            maxWidth: '600px',
            borderRadius: '16px',
            // marginTop: '40px',
            // marginBottom: '40px',
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
            overflow: 'hidden',
        },
    },
    children: [section],
};
const body = {
    type: 'body',
    attributes: {
        style: {
            backgroundColor: '#f3f3f6',
            paddingTop: '40px',
            paddingBottom: '40px',
        },
        lang: '$theme.lang',
    },
    children: [container],
};

const html = {
    type: 'html',
    // attributes: { style: {}, lang: i18n.language, dir: i18n.dir() },
    // attributes: { style: {}, lang: 'en' },
    attributes: { style: {}, lang: '$theme.lang' },
    globalStyles,
    theme,
    children: [body],
};

const button = {
    type: 'button',
    attributes: {
        style: {},
    },
    containerAttributes: {
        style: {
            textAlign: 'center',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    },
    children: [{ text: t('Button') }],
};

const image = {
    type: 'image',
    attributes: {
        src: '',
        style: {
            maxWidth: '100%',
            objectFit: 'cover',
            margin: '0 auto',
            width: '100%',
            boxSizing: 'border-box',
        },
    },
    containerAttributes: {
        style: {
            // display: 'flex',
            paddingTop: '12px',
            paddingBottom: '12px',
            paddingLeft: '24px',
            paddingRight: '24px',
            justifyContent: 'center',
        },
    },
    children: [text],
};
const logo = {
    type: 'image',
    attributes: {
        src: 'https://www.donbar.org/static/media/logo.c830793a27519d8dc9cca633be340714.svg',
        style: {
            maxWidth: '100%',
            boxSizing: 'border-box',
            width: '140px',
            borderRadius: '16px',
        },
    },
    containerAttributes: {
        style: {
            display: 'flex',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '24px',
            paddingRight: '24px',
            justifyContent: 'center',
        },
    },
    children: [text],
};
const divider = {
    type: 'divider',
    attributes: {
        style: {
            borderTopColor: '#006495',
            borderTopWidth: '2px',
            borderTopStyle: 'solid',
            borderRadius: '2px',
        },
    },
    containerAttributes: {
        style: {
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    },
    children: [text],
};

const spacer = {
    type: 'spacer',
    attributes: {
        style: {
            height: '24px',
        },
    },
    children: [text],
};

const softBreak = {
    type: 'soft-break',
    children: [text],
};

const file = {
    ...button,
    children: [{ text: t('Download File') }],
};

export const elements = {
    html: {
        node: html,
    },
    body: {
        node: body,
    },
    section: {
        node: section,
        // blockIcon: ViewQuiltTwoTone,
        blockIcon: ViewComfyTwoTone,
        panel: SectionPanel,
        blockLabel: 'Section',
        panelTitle: 'Section',
        isSelectableBlock: true,
    },
    placeholder: {
        node: placeholder,
    },
    column: {
        node: column,
        blockIcon: ViewArrayTwoTone,
        blockLabel: 'Column',
    },
    row: {
        node: row,
        blockIcon: CalendarViewDayTwoTone,
        blockLabel: 'Row',
    },
    container: {
        node: container,
    },
    'rich-text': {
        node: richText,
        panel: TextPanel,
        panelTitle: 'Text',
        blockLabel: 'Text',
        blockIcon: WysiwygTwoTone,
        isSelectableBlock: true,
    },
    heading: {
        node: heading,
        blockLabel: 'Heading',
        blockIcon: TextFieldsTwoTone,
    },
    button: {
        node: button,
        panel: ButtonPanel,
        blockIcon: SmartButtonTwoTone,
        panelTitle: 'Button',
        blockLabel: 'Button',
        isSelectableBlock: true,
    },
    image: {
        node: image,
        panel: ImagePanel,
        void: true,
        blockIcon: PhotoSizeSelectActualTwoTone,
        panelTitle: 'Image',
        blockLabel: 'Image',
        isSelectableBlock: true,
    },
    logo: {
        node: logo,
        panelTitle: 'Logo',
        blockLabel: 'Logo',
        blockIcon: SpaTwoTone,
    },
    file: {
        node: file,
        panelTitle: 'File',
        blockLabel: 'File',
        blockIcon: AttachEmailTwoTone,
    },
    spacer: {
        node: spacer,
        void: true,
        panel: SpacerPanel,
        blockIcon: SpaceBarTwoTone,
        panelTitle: 'Spacer',
        blockLabel: 'Spacer',
        isSelectableBlock: true,
    },
    divider: {
        node: divider,
        void: true,
        panel: DividerPanel,
        blockIcon: HorizontalRuleTwoTone,
        panelTitle: 'Divider',
        blockLabel: 'Divider',
        isSelectableBlock: true,
    },
    'soft-break': {
        node: softBreak,
        inline: true,
        void: true,
    },
    link: {
        inline: true,
    },
    paragraph: {
        node: paragraph,
    },
    'merge-tag': {
        inline: true,
        void: true,
    },
};

export const innerBlocks = [
    'rich-text',
    'button',
    'divider',
    'spacer',
    'image',
    'logo',
    'heading',
    'file',
];

export const headingBlocks = [
    'heading-one',
    'heading-two',
    'heading-three',
    'heading-four',
];

export const gridBlocks = ['column', 'row'];
export const layoutBlocks = ['section', 'container', 'body'];
export const blockLements = [...layoutBlocks, ...gridBlocks, ...innerBlocks];
